import { Component, OnInit, Input } from '@angular/core';
// import { MessageDialogService, MessageDialogType } from './message-dialog.service';

//declare var require: any;
@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss'],
})

export class MessageDialogComponent implements OnInit {
  // @Input()
  // type: MessageDialogType;
  // @Input()
  // style:{}
  @Input() message:string = '';
  icon;

  constructor(
//    private _messageDialogService: MessageDialogService
  ) { }

  ngOnInit() {
    // this.getIcon();
    // this._messageDialogService.messageDialogSource$.subscribe(state => {
    //   this.message = state.message;
    //   this.type = state.type;
    //   this.getIcon();
    // });
  }

  getIcon() {
    // switch (this.type) {
    //   case (MessageDialogType.Info): {
    //     this.icon = './assets/icons/info.png';
    //     break;
    //   }
    //   case (MessageDialogType.Success): {
    //     this.icon = './assets/icons/success.png';
    //     break;
    //   }
    //   case (MessageDialogType.Warning): {
    //     this.icon = './assets/icons/warning.png';
    //     break;
    //   }
    //   case (MessageDialogType.Danger): {
    //     this.icon = './assets/icons/danger.png';
    //     break;
    //   }
    //   case (MessageDialogType.Emoji1): {
    //     this.icon = './assets/icons/emoji1.png';
    //     break;
    //   }
    //   case (MessageDialogType.Emoji2): {
    //     this.icon = './assets/icons/emoji2.png';
    //     break;
    //   }
    //   case (MessageDialogType.Emoji3): {
    //     this.icon = './assets/icons/emoji3.png';
    //     break;
    //   }
    //   case (MessageDialogType.Emoji4): {
    //     this.icon = './assets/icons/emoji4.png';
    //     break;
    //   }
    //   case (MessageDialogType.Emoji5): {
    //     this.icon = './assets/icons/emoji5.png';
    //     break;
    //   }
    //   case (MessageDialogType.Emoji6): {
    //     this.icon = './assets/icons/emoji6.png';
    //     break;
    //   }
    //   case (MessageDialogType.Emoji7): {
    //     this.icon = './assets/icons/emoji7.png';
    //     break;
    //   }
    //   case (MessageDialogType.Emoji8): {
    //     this.icon = './assets/icons/emoji8.png';
    //     break;
    //   }
    //   default: {
    //     this.icon = undefined;
    //   }
    // }
  }
}
